/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noble_Cute_Flamingo_StopInputs */

const fr_noble_cute_flamingo_stop = /** @type {(inputs: Noble_Cute_Flamingo_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter un cours ajoutera les 2 personnes automatiquement.`)
};

/**

* @param {Noble_Cute_Flamingo_StopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const noble_cute_flamingo_stop = /** @type {((inputs?: Noble_Cute_Flamingo_StopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noble_Cute_Flamingo_StopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_noble_cute_flamingo_stop(inputs)
});